<ion-header>
  <ion-toolbar *ngIf="header">
    <ion-title>
      {{ header }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [scrollY]="true" class="ion-padding content">
  <ion-grid>
    <ion-row *ngIf="message">
      <ion-col class="ion-padding ion-text-center">
        {{ message }}
      </ion-col>
    </ion-row>
    <ion-row *ngIf="image" class="ion-row-expand">
      <ion-col class="ion-padding ion-text-center">
        <img [src]="image" alt="" />
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        (click)="dismiss()"
        fill="outline"
        shape="round"
        size="default"
        >OK</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
